(function () {
    "use strict";

    angular.module("iMatApp")
        .factory("eventService", eventService);

    eventService.$inject = ["$rootScope",  "$timeout", "$log", "guard"];

    function eventService($rootScope, $timeout, $log, guard) {
        return {
            subscribe: function (scope, eventName, callback) {
                guard.argumentIsObject(scope, "scope");
                guard.argumentIsString(eventName, "eventname");
                guard.argumentIsFunction(callback, "calback");
                
                $log.debug("Subscribe on '" + eventName + "'. Scope.id=" + scope.$id);
                var handler = $rootScope.$on(eventName, function (event, data) {
                    callback(data);
                });

                scope.$on("$destroy", function () {
                    $log.debug("$destroy on '" + eventName + "'. Scope.id=" + scope.$id);
                    handler();
                });

                return handler;
            },

            notify: function (eventName, data) {
                guard.argumentIsString(eventName, "eventname");

                $timeout(function() {
                    $rootScope.$emit(eventName, data);
                });
            }
        };
    }
})();